import React from "react";

/**
 * Wraps the portions of `text` that match `query` in a highlight span.
 * Used in Mafia list screens so search hits are visually obvious in rows
 * (a standard enterprise-table affordance). Case-insensitive, safe on
 * empty/[]/regex-special input. Mafia-scoped (not the shared kit).
 */
export function highlightMatch(text, query) {
  const str = text == null ? "" : String(text);
  const q = (query || "").trim();
  if (!q) return str;

  // escape regex specials in the user's query
  const safe = q.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
  const parts = str.split(new RegExp(`(${safe})`, "ig"));
  if (parts.length === 1) return str;

  return parts.map((part, i) =>
    part.toLowerCase() === q.toLowerCase() ? (
      <mark key={i} className="mafia-hl">
        {part}
      </mark>
    ) : (
      <React.Fragment key={i}>{part}</React.Fragment>
    )
  );
}

/** One-time style for the highlight mark; import-and-render once per page. */
export const MafiaHighlightStyle = () => (
  <style>{`.mafia-hl{ background:#fff3c4; color:inherit; padding:0 1px; border-radius:2px; }`}</style>
);
